import styled from 'styled-components'
import { BREAKPOINTS } from 'styles/constants'

export const UserListStyled = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`

export const UserListTitle = styled.div`
  font-weight: 500;
  line-height: 20px;
`

export const UserListGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;

  @media (max-width: ${BREAKPOINTS.mobile}) {
    grid-template-columns: 1fr;
  }
`

export const UserElem = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;

  &:nth-child(odd) {
    padding-right: 24px;
    border-right: 1px solid transparent;
  }

  &:nth-child(odd):not(:only-child) {
    border-right: 1px solid var(--t-separator-border-primary);
  }

  &:nth-child(even) {
    margin-left: 24px;
  }
`

export const UserCard = styled.div`
  width: calc(100% - 30px);
`
